import { put, takeLatest, select } from 'redux-saga/effects';

import CustomerQuotation from '../../../models/CustomerQuotation';

import { SALESFORCE_DATA_READY } from '../SFDataService/actions';

import * as Actions from './actions';

export function* populateCustomerQuotation(action) {
  let quote = yield select(state => state.customerQuotation);
  if (action.quotation !== null) {
    if (quote === null) {
      quote = new CustomerQuotation(
        action.quotation.getId(),
        action.quotation.getOpportunityId(),
        action.quotation.getProductLines(),
      );
    } else {
      quote = quote
        .clone()
        .setId(action.quotation._id)
        .setOpportunityId(action.quotation._opportunityId)
        .setProductLines(action.quotation._productLines);
    }
  }
  yield put(Actions.customerQuotationRetrieved(quote));
}

export function* customerQuotationListener() {
  yield takeLatest(SALESFORCE_DATA_READY, populateCustomerQuotation);
}



// WEBPACK FOOTER //
// ./src/services/DataServices/CustomerQuotationService/saga.js